module.exports = __webpack_public_path__ + "e5598cddad2a66bf586954a03f5bcd2d.pdf";